import { useNavigate } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { ITown, ITownClick } from "../../models/model";

const useStyles = makeStyles(theme => ({
    townList: {
        margin: theme.spacing(2),
    },
    neighborhoodTitleArea: {
        paddingLeft: theme.spacing(2),
    },
    neighborhoodTitle: {
        fontWeight: "bolder",
        fontSize: "16px",
    },
    neighborhoodArea: {
        paddingLeft: theme.spacing(3),
    },
    neighborhood: {
        fontSize: "14px",
        color: "#1D83BD",
        borderBottom: "1px solid #1D83BD",
        cursor: "pointer",
    },
}));

export default function TownDetailNeighborhood(props: { neighborhoodList: ITown[]; userId: string }) {
    const classes = useStyles();
    const navigate = useNavigate();

    const neighborhoodList = props.neighborhoodList;
    const userId = props.userId;

    // 街ページへ
    const townClick: ITownClick = (townId: number) => {
        navigate(`/town_detail/${townId}?user_id=${userId}`, { state: { type: "success" } });
    };

    return (
        <div className={classes.townList}>
            <Grid container direction="column" spacing={0}>
                <Grid item xs>
                    <div className={classes.neighborhoodTitleArea}>
                        <span className={classes.neighborhoodTitle}>近隣の街</span>
                    </div>
                </Grid>
                <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    className={classes.neighborhoodArea}
                    spacing={1}
                    xs
                >
                    {neighborhoodList.map((town, index) => (
                        <Grid item key={index} xs={6}>
                            <span
                                className={classes.neighborhood}
                                onClick={() => {
                                    townClick(town.town_id);
                                }}
                            >
                                {`${town.ward_name} ${town.town_name}`}
                            </span>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </div>
    );
}
